<plex-tabs size="full" [activeIndex]="showTab">
    <plex-tab icon="information" label="Datos">
        <!--Header de estadisticas-->
        <ng-container *ngIf="paciente">
            <paciente-detalle [paciente]="paciente" orientacion="horizontal" [fields]="pacienteFields">
            </paciente-detalle>
            <br>
            <update-contacto-direccion [pac]="paciente"></update-contacto-direccion>
        </ng-container>
    </plex-tab>
    <plex-tab icon="clock" label="Turnos">
        <turnos-paciente [paciente]='paciente' [turnos]="turnosPaciente$ | async" [operacion]="'operacionTurnos'"
            (turnosPacienteChanged)="refresh()" *plTab>
        </turnos-paciente>
        <ng-container *ngIf="demandaInsatisfecha">
            <demandaInsatisfecha (demandaCerrada)="cerrarDemandaInsatisfecha()" [paciente]='paciente'>
            </demandaInsatisfecha>
        </ng-container>
    </plex-tab>
    <plex-tab icon="history" label="Historial" *ngIf="!(paciente | pacienteRestringido)">
        <fieldset *plTab>
            <plex-title size="sm" titulo="Historial de turnos"></plex-title>
            <plex-wrapper>
                <plex-datetime grow="1" type="date" [(ngModel)]="fechaDesde" name="fechaDesde" [debounce]="600"
                    label="Fecha desde" class="fechas" (change)="filtrar()" [max]="fechaHasta">
                </plex-datetime>
                <plex-datetime grow="1" type="date" [(ngModel)]="fechaHasta" name="fechaHasta" [debounce]="600"
                    label="Fecha hasta" class="fechas" (change)="filtrar()" [min]="fechaDesde">
                </plex-datetime>
                <plex-select [(ngModel)]="estadoTurno" name="estadoTurno" label="Estado" [data]="estados"
                    (change)="filtrar()"></plex-select>
                <plex-select label="Prestación" name="prestacion" [(ngModel)]="prestacion" labelField="term"
                    tmPrestaciones="rup:tipoPrestacion:?" [preload]="true" (change)="filtrar()">
                </plex-select>
            </plex-wrapper>

            <ng-container *ngIf="(ultimosTurnos$ | async) as ultimosTurnos">
                <div class="contenedor-turnos-vacio" *ngIf="!ultimosTurnos?.length" justify="center">
                    <plex-label class="label-turnos-vacio" icon="turno-bold" type="info" size="lg" direction="column"
                        titulo="No se han encontrado turnos registrados para el paciente.">
                    </plex-label>
                </div>
                <ng-container *ngIf="ultimosTurnos?.length">
                    <plex-table [columns]="columns" #table="plTable" (scroll)="onScroll()" [height]="580"
                        [headOpacity]="10">
                        <plex-table-columns>
                        </plex-table-columns>

                        <tr *ngFor="let turno of ultimosTurnos">
                            <td *plTableCol="'fecha'">{{turno.horaInicio | date:'dd/MM/yyyy HH:mm'}}</td>
                            <td *plTableCol="'prestacion'">{{turno.tipoPrestacion?.term}}</td>
                            <td *plTableCol="'profesional'">
                                <ng-container *ngFor="let profesional of turno.profesionales">
                                    {{profesional | nombre}}
                                </ng-container>
                            </td>
                            <td *plTableCol="'obraSocial'">
                                <ng-container *ngIf="turno.paciente.obraSocial">
                                    {{turno.paciente.obraSocial.nombre || turno.paciente.obraSocial.financiador}}
                                </ng-container>
                                <ng-container *ngIf="!turno.paciente.obraSocial">
                                    Sin obra social
                                </ng-container>
                            </td>
                            <td *plTableCol="'organizacion'">
                                <div>
                                    <em class="small">{{turno.organizacion.nombre}}</em>
                                </div>
                            </td>
                            <td *plTableCol="'estado'">
                                <plex-badge *ngIf="turno.asistencia === 'noAsistio' && turno.estado !== 'suspendido'"
                                    type="danger">NO ASISTIÓ</plex-badge>
                                <plex-badge *ngIf="turno.estado === 'fuera-agenda'" type="warning">
                                    FUERA DE AGENDA</plex-badge>
                                <plex-badge
                                    *ngIf="turno.asistencia !== 'noAsistio' && (turno.estado === 'asignado' || turno.estado === 'turnoDoble')"
                                    type="success">
                                    ASIGNADO</plex-badge>
                                <div class="d-flex align-items-center">
                                    <plex-badge *ngIf="turno.estado === 'liberado' || turno.estado === 'suspendido'"
                                        type="danger" [hint]="(turno.reasignado) ? 'Reasignado' : null"
                                        hintType="danger">
                                        {{ turno.estado | uppercase }}
                                    </plex-badge>
                                    <plex-help *ngIf="turno.estado === 'liberado'" class="ml-1"
                                        icon="information-variant" btnType="danger">
                                        <plex-title size="sm" titulo="Datos del turno"></plex-title>
                                        <div class="row">
                                            <div class="col-12">
                                                <label>Liberado por </label> {{ turno.updatedBy | nombre }}
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-12">
                                                <label>Fecha y hora de liberación </label> {{ turno.updatedAt |
                                                date:'dd/MM/yyyy HH:mm'}}
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-12">
                                                <label>Motivo de liberación </label> {{ turno.observaciones }}
                                            </div>
                                        </div>
                                    </plex-help>
                                </div>
                            </td>
                        </tr>
                    </plex-table>
                </ng-container>
            </ng-container>
        </fieldset>
    </plex-tab>
    <plex-tab icon="folder-account" label="Carpetas">
        <carpeta-paciente *plTab [pacienteSeleccionado]="paciente"> </carpeta-paciente>
    </plex-tab>
</plex-tabs>